// import "../css/style.scss"
import "../assets/js/main.js";
import RoutemParticleHandler from "./parts/RoutemParticleHandler.js";
import { getDeviceId, loadTreatments } from "./parts/splitHandler.js";
import { deepEqual } from "./parts/utils.js";

const routemParticleHandler = new RoutemParticleHandler();

function logSplitFlagCheckedEvent(treatment, config) {
  if (config?.fire_check_event)
    routemParticleHandler.sendEvent(
      "Flag-Checked-Experiment_Route_Com_Business_Shoppers_Homepage",
      {
        flag_name: "Experiment_Route_Com_Business_Shoppers_Homepage",
        treatment: treatment,
        rule: "default rule",
      }
    );
}

function getAndPushmParticleArrayLocalStorage(eventName, eventBody) {
  const storedArray = localStorage.getItem("mParticleEventsArray");

  const mParticleEventsArray =
    storedArray && storedArray !== "" ? JSON.parse(storedArray) : [];

  mParticleEventsArray.push({
    eventName: eventName,
    body: eventBody,
  });

  localStorage.setItem(
    "mParticleEventsArray",
    JSON.stringify(mParticleEventsArray)
  );
}

function validateIfmParticleIdentityIsReady() {
  const hasmParticleIdentityObjectSet =
    mParticle.Identity && mParticle.Identity.getCurrentUser; // Validate if we have a valid Identity and getCurrentUser object, we test that so we don't try to call a value that's undefined (mParticle.Identity.getCurrentUser())
  const mParticleCurrentUser = hasmParticleIdentityObjectSet
    ? mParticle.Identity.getCurrentUser()
    : null; // Uses validation to get current mPartifle user or a null
  return (
    mParticleCurrentUser &&
    mParticleCurrentUser.getUserIdentities().userIdentities.other &&
    mParticleCurrentUser.getUserIdentities().userIdentities.other !== "" &&
    mParticleCurrentUser.getUserIdentities().userIdentities.other ===
      getDeviceId()
  ); // doing the actual identity validation checking if the other prop exists and has value
}

document.addEventListener("DOMContentLoaded", () => {
  const deviceId = getDeviceId();

  loadTreatments(deviceId, (treatments) => {
    const keys = Object.keys(treatments);
    keys.forEach((key) => {
      const localKey = localStorage.getItem(`splitio-${key}`);
      const { treatment, config } = treatments[key];
      if (
        !localKey ||
        !deepEqual(JSON.parse(localKey), {
          treatment,
          config: JSON.parse(config),
        })
      ) {
        localStorage.setItem(
          `splitio-${key}`,
          JSON.stringify({ treatment, config: JSON.parse(config) })
        );
        document.dispatchEvent(
          new CustomEvent(`splitio-${key}`, {
            detail: {
              treatment: { treatment, config: JSON.parse(config) },
            },
          })
        );
      }
    });
  });
});

window.addEventListener("DOMContentLoaded", () => {
  if (
    document.querySelector("html").getAttribute("force_smooth-scroll") != null
  ) {
    document.querySelector("html").classList.add("force_smooth-scroll");
  }

  const localTreatment = JSON.parse(
    localStorage.getItem(
      "splitio-Experiment_Route_Com_Business_Shoppers_Homepage"
    )
  );

  const location = window.location.pathname;
  const validPaths = ["/", "/shoppers", "/merchants"];
  if (localTreatment && validPaths.includes(location)) {
    const isMparticleIdentityReady = validateIfmParticleIdentityIsReady();

    const { treatment, config } = localTreatment;

    if (isMparticleIdentityReady) {
      logSplitFlagCheckedEvent(treatment, config);
    } else {
      if (config?.fire_check_event) {
        getAndPushmParticleArrayLocalStorage(
          "Flag-Checked-Experiment_Route_Com_Business_Shoppers_Homepage",
          {
            flag_name: "Experiment_Route_Com_Business_Shoppers_Homepage",
            treatment: treatment,
            rule: "default rule",
          }
        );
      }
    }
  }
});

document.addEventListener(
  "splitio-Experiment_Route_Com_Business_Shoppers_Homepage",
  (e) => {
    const isMparticleIdentityReady = validateIfmParticleIdentityIsReady();

    const { treatment, config } = e.detail.treatment;

    if (isMparticleIdentityReady) {
      logSplitFlagCheckedEvent(treatment, config);
    } else {
      if (config?.fire_check_event) {
        getAndPushmParticleArrayLocalStorage(
          "Flag-Checked-Experiment_Route_Com_Business_Shoppers_Homepage",
          {
            flag_name: "Experiment_Route_Com_Business_Shoppers_Homepage",
            treatment: treatment,
            rule: "default rule",
          }
        );
      }
    }
  }
);
// window.addEventListener("beforeunload", () => {
//     if( document.querySelector("#loader") ) {
//         document.querySelector("#loader").style.display = "flex";
//         document.querySelector("#loader").classList.remove("inactive");
//     }
//     // document.querySelector("html").classList.add("loading");
// });
